import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import DropDownContainer, { DropDown } from '../DropDown';
import Tag from '../Tag';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "TagList-root_23R5w",
  "list": "TagList-list_2vAuV",
  "item": "TagList-item_Y2w1A",
  "dropdown": "TagList-dropdown_2Ve-I"
};
function List({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "ul",
    flexInline: true,
    flexWrap: true,
    gap: "xxsmall",
    marginY: "none",
    paddingX: "none",
    listStyleType: "none",
    className: clsx(styles.list, className),
    ...extraProps
  });
}
function renderTag(tag) {
  const {
    render,
    label,
    ...rest
  } = tag;
  const tagElement = typeof render === 'function' ? render(tag) : /*#__PURE__*/_jsx(Tag, {
    ...rest,
    children: label
  });
  return /*#__PURE__*/_jsx("li", {
    className: styles.item,
    children: tagElement
  }, label);
}
function More({
  id,
  tags,
  theme
}) {
  return /*#__PURE__*/_jsx("li", {
    className: styles.item,
    children: /*#__PURE__*/_jsx(DropDownContainer, {
      id: `${id}-dropdown`,
      placement: "bottom",
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 4]
        }
      }],
      renderReference: getReferenceProps => /*#__PURE__*/_jsxs(Tag, {
        theme: theme,
        ...getReferenceProps(),
        children: ["+ ", tags.length]
      }),
      children: getDropDownProps => /*#__PURE__*/_jsx(DropDown, {
        paddingX: "xsmall",
        className: styles.dropdown,
        ...getDropDownProps(),
        children: /*#__PURE__*/_jsx(List, {
          children: tags.map(renderTag)
        })
      })
    })
  });
}
function TagList({
  id,
  tags,
  theme = 'grey',
  max,
  className,
  ...extraProps
}) {
  const hasTags = Array.isArray(tags) && tags.length > 0;
  const hasMore = typeof max === 'number' && hasTags && tags.length > max;
  if (!hasTags) {
    return null;
  }
  const all = Array.from(tags, tag => ({
    theme,
    ...tag
  }));
  const shown = all.slice(0, max);
  const more = all.slice(max);
  return /*#__PURE__*/_jsxs(List, {
    className: clsx(styles.root, className),
    ...extraProps,
    children: [shown.map(renderTag), hasMore && /*#__PURE__*/_jsx(More, {
      id: id,
      tags: more,
      theme: theme
    })]
  });
}
export default TagList;